import { Injectable } from '@angular/core';

import 'rxjs/Rx';

import { QueryService } from './query.service';
import { Size } from '../_models/size';


@Injectable()
export class SharedService {
  public cardSizes: Size[] = [];

  constructor(private queryService: QueryService) {
    this.getCartSizes();
  }

  getCartSizes(): void {
    const url = '/cards/sizes/';
    this.queryService.getQuery(url).subscribe(result => this.cardSizes = result);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/shared.service.ts